import React, { useEffect } from 'react';
import {
    useProperty,
    usePropertyComplementaryData,
    usePropertyFetching,
    usePropertyValidation,
} from '../../../contextsProperty/ContextProperties';
import TextInput from '../../../../muiComponents/TextInput/TextInputV2';
import LoadedOptionsTypeahead from '../../../../muiComponents/LoadedOptionsTypeahead';
import Card from '../../../../muiComponents/Card';
import Grid from '../../../../muiComponents/Grid';
import GridChild from '../../../../muiComponents/GridChild';
import { doubleColumnGrid } from '../../../../utils/property/propertyUtils';
import { PROGRESS_MAIN_INFORMATION_TAB } from '../../../../types/properties/propertyTypes';
import '../../../../stylesheets/stylesLayout/yourProperties.scss';
import LoadingTab from '../LoadingTab';
import Title from '../Title';
import {
    gridSpacing30,
    gridSpacing40,
} from '../../../../utils/commonVariables/grid';

export default function Commercial() {
    const {
        primary,
        address,
        idCountry,
        idRegion,
        idProvince,
        idCity,
        postalCode,
        handleResetLocation,
        handleInputChange,
    } = useProperty();
    const { countriesList, regionsList, provincesList, citiesList } =
        usePropertyComplementaryData();
    const { handleIsValidated, errors, isValidated, handleValidate } =
        usePropertyValidation();
    const { isFetching } = usePropertyFetching();

    useEffect(() => {
        return () => handleIsValidated(false);
    }, []);

    const handleBlur = () => {
        if (isValidated) {
            handleValidate(PROGRESS_MAIN_INFORMATION_TAB.LOCATION);
        }
    };

    const autocompleteInputProps = {
        sx: {
            '& .MuiOutlinedInput-root': {
                height: '50px',
                fontSize: '1.2rem',
            },
            '& .MuiFilledInput-root': {
                height: '50px',
                fontSize: '1.2rem',
            },
            '& .MuiInputLabel-shrink': {
                top: '0 !important',
            },
            '& .MuiInputLabel-outlined': {
                fontSize: '1.2rem',
                // top: '-5px',
            },
            '& .MuiInputLabel-filled': {
                fontSize: '1.2rem',
                top: '-5px',
            },
        },
        variant: !primary ? 'filled' : 'outlined',
    };

    if (isFetching) {
        return <LoadingTab />;
    }

    return (
        <div className='your-property__container'>
            <Title
                as='h1'
                text={'location_title'}
                className='text-align-center'
            />
            <Card className='your-properties__form'>
                <Grid columnSpacing={gridSpacing30} rowSpacing={gridSpacing40}>
                    <GridChild gridProps={doubleColumnGrid}>
                        <TextInput
                            labelText='full_address'
                            handleChange={e =>
                                handleInputChange('address', e.target.value)
                            }
                            value={address}
                            errorMessage={errors.address}
                            onBlur={handleBlur}
                            name='address'
                            type='text'
                            required
                            id='address'
                            disabled={!primary}
                            variant={!primary ? 'filled' : 'outlined'}
                            error={!!errors.address}
                        />
                    </GridChild>
                    <GridChild gridProps={doubleColumnGrid}>
                        <LoadedOptionsTypeahead
                            labelText='Country'
                            options={countriesList}
                            handleChange={(e, newValue) => {
                                handleInputChange(
                                    'idCountry',
                                    newValue ? parseInt(newValue.id) : 0
                                );
                                handleResetLocation();
                            }}
                            idValue={idCountry}
                            idValueKey='id'
                            optionsLabelKey='name'
                            onBlur={handleBlur}
                            errorMessage={errors.idCountry}
                            required
                            disabled={!primary}
                            error={!!errors.idCountry}
                            inputProps={autocompleteInputProps}
                            name='idCountry'
                        />
                    </GridChild>
                    <GridChild gridProps={doubleColumnGrid}>
                        <LoadedOptionsTypeahead
                            labelText='region'
                            options={regionsList}
                            handleChange={(e, newValue) => {
                                handleInputChange(
                                    'idRegion',
                                    newValue ? parseInt(newValue.id) : 0
                                );
                            }}
                            optionsLabelKey='name'
                            idValueKey='id'
                            idValue={idRegion}
                            disabled={!primary}
                            inputProps={autocompleteInputProps}
                            name='idRegion'
                        />
                    </GridChild>
                    <GridChild gridProps={doubleColumnGrid}>
                        <LoadedOptionsTypeahead
                            labelText='province'
                            options={provincesList}
                            handleChange={(e, newValue) => {
                                handleInputChange(
                                    'idProvince',
                                    newValue ? parseInt(newValue.id) : 0
                                );
                            }}
                            optionsLabelKey='name'
                            idValue={idProvince}
                            idValueKey='id'
                            disabled={!primary}
                            inputProps={autocompleteInputProps}
                            name='idProvince'
                        />
                    </GridChild>
                    <GridChild gridProps={doubleColumnGrid}>
                        <LoadedOptionsTypeahead
                            labelText='City'
                            options={citiesList}
                            handleChange={(e, newValue) => {
                                handleInputChange(
                                    'idCity',
                                    newValue ? parseInt(newValue.id) : 0
                                );
                            }}
                            optionsLabelKey='name'
                            idValue={idCity}
                            idValueKey='id'
                            onBlur={handleBlur}
                            errorMessage={errors.idCity}
                            required
                            disabled={!primary}
                            error={!!errors.idCity}
                            inputProps={autocompleteInputProps}
                            name='idCity'
                        />
                    </GridChild>
                    <GridChild gridProps={doubleColumnGrid}>
                        <TextInput
                            labelText='postal_code'
                            handleChange={e =>
                                handleInputChange('postalCode', e.target.value)
                            }
                            value={postalCode}
                            errorMessage={errors.postalCode}
                            onBlur={handleBlur}
                            name='postalCode'
                            type='text'
                            required
                            id='postalCode'
                            disabled={!primary}
                            variant={!primary ? 'filled' : 'outlined'}
                            error={!!errors.postalCode}
                        />
                    </GridChild>
                </Grid>
            </Card>
        </div>
    );
}
